import { createAsyncThunk, createSlice, SerializedError } from '@reduxjs/toolkit';
import axios from 'axios';
import { IOrganizationInfo } from '../interfaces/organizationInfo';
import { isFetching, error } from './common';

const name = 'organizationInfo';

export const fetchOrganizationInfo = createAsyncThunk(name, async (organizationId: string) => {
  const { data } = await axios.get(`/api/v3.03/organizations/${organizationId}/info`);
  return data;
});

export type State = {
  isFetching: boolean;
  organizationInfo: IOrganizationInfo | null;
  error: SerializedError | null;
};

export const initialState: State = {
  isFetching: false,
  organizationInfo: null,
  error: null
};

const organizationInfo = createSlice({
  name,
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(fetchOrganizationInfo.pending, isFetching);
    builder.addCase(fetchOrganizationInfo.fulfilled, (state, action) => {
      state.isFetching = false;
      state.organizationInfo = action.payload;
    });
    builder.addCase(fetchOrganizationInfo.rejected, error);
  }
});

export const { reducer: organizationInfoReducer } = organizationInfo;
